/*
 * @Author: Chao Yang
 * @Date: 2020-01-20 09:30:53
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 09:35:12
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Account from 'src/app/domain/model/account';
import { BaseProxy } from '../base.proxy';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { environment } from 'src/environments/environment';

@Injectable()
export class DetailProxy extends BaseProxy {
  getAccounts(
    accounts2: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IProfile[]> {
    return this._http.post<Account.IProfile[]>(
      '/ip/api/account/detail',
      accounts2
    );
  }

  getAuthorizedAccounts(
    accounts2: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IProfile[]> {
    if (environment.feature.newApi === false) {
      return this._http.post<Account.IProfile[]>(
        '/ip/api/account/detail/authorized',
        accounts2
      );
    } else {
      return this._http.post<Account.IProfile[]>(
        '/ip-api/api/bankaccount/authorized',
        accounts2 || []
      );
    }
  }

  getAccountTypeColor(): Observable<Account.IColor> {
    return this._http.get<Account.IColor>('/ip/api/account/type/color');
  }

  getMaxAsOfDate(fundId: number): Observable<string> {
    return this._http.get<string>(`/ip/api/fund/${fundId}/maxasofdate`);
  }

  readyToPublish(fundId: number, date: string): Observable<boolean> {
    return this._http.get<boolean>(
      `/ip/api/fund/${fundId}/readyToPublish?date=${date}`
    );
  }

  publish(input: any): Observable<number> {
    return this._http.post<number>(`/ip/api/fund/publish`, input);
  }
}
